module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/iron-da33de150d5a43d11816172cb7622054.svg";